// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--kra1_","stretch":"_7a3fb80146--stretch--xdInY"};